import React from "react";
import Slider from "react-slick";
import styled from "styled-components";
// Components
import TestimonialBox from "../Elements/TestimonialBox";
//Assets
import IconRating from "../../assets/img/testimonial/icon-rating.png"

export default function TestimonialSlider() {
  const settings = {
    infinite: true,
    autoplaySpeed: 6000,
    autoplay: true,
    pauseOnHover: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 1250,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: true
        },
      },
      {
        breakpoint: 859,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true
        },
      },
    ],
  };

  return (
    <Wrapper id="testimonial">
      <div className="container">
        <TestimonialTitle>
          Veja algumas avaliações de nossos clientes
        </TestimonialTitle>
        <Slider {...settings}>
          <LogoWrapper className="flexCenter">
            <TestimonialBox
              text="Quebrou um galho para mim quando precisei. Chamei tarde da noite e prontamente veio me atender. Preço justo. Recomendo!"
              author="Israel Júnior"
            />
          </LogoWrapper>
          <LogoWrapper className="flexCenter">
            <TestimonialBox
              text="Excelente serviço! Recomendo a todos."
              author="Rodrigo Mello"
            />
          </LogoWrapper>
          <LogoWrapper className="flexCenter">
            <TestimonialBox
              text="Não tenho dúvidas que são os melhores da cidade, preço bom e justo. Precisei deles com urgência e foi tudo muito rápido, trabalho limpo e muito bem feito parabéns"
              author="Felipe Silva"
            />
          </LogoWrapper>
          <LogoWrapper className="flexCenter">
            <TestimonialBox
              text="Chaveiro tradicional bem no centro de Florianópolis ha muitos anos trabalhando com seriedade, competência e preço justo!"
              author="Thiago Mafra"
            />
          </LogoWrapper>
          <LogoWrapper className="flexCenter">
            <TestimonialBox
              text="Atendimento excelente e produtos de qualidade. Recomendo sempre!"
              author="Cyntia Jorge"
            />
          </LogoWrapper>
          <LogoWrapper className="flexCenter">
            <TestimonialBox
              text="Melhor atendimento da cidade! Trabalho impecável e rápido."
              author="Caroline Figueiredo"
            />
          </LogoWrapper>
          <LogoWrapper className="flexCenter">
            <TestimonialBox
              text="O mais top da cidade!!!"
              author="Dr. Eduardo Parente"
            />
          </LogoWrapper>
          <LogoWrapper className="flexCenter">
            <TestimonialBox
              text="Atendimento rápido e qualificado!"
              author="Anderson Emmerich"
            />
          </LogoWrapper>
          <LogoWrapper className="flexCenter">
            <TestimonialBox
              text="Ótimo serviço."
              author="Luiza Crippa de Oliveira"
            />
          </LogoWrapper>
          <LogoWrapper className="flexCenter">
            <TestimonialBox
              text="Atendimento rápido e de qualidade!"
              author="Rosiane Morais"
            />
          </LogoWrapper>
          <LogoWrapper className="flexCenter">
            <TestimonialBox
              text="Excelente atendimento, recomendo a todos!!"
              author="Samuel Monteiro"
            />
          </LogoWrapper>
          <LogoWrapper className="flexCenter">
            <TestimonialBox
              text="Ótimo atendimento e serviço de qualidade."
              author="Karina Jorge"
            />
          </LogoWrapper>
          <LogoWrapper className="flexCenter">
            <TestimonialBox
              text="Muitos produtos e ótimos preços e atendimento."
              author="Augustinho Monteiro"
            />
          </LogoWrapper>
        </Slider>
        <div>
          <Anchor
            href="https://www.google.com/maps/place/Chaveiro.24hcentro+36+anos/@-27.6540181,-48.428766,12.45z/data=!4m14!1m5!8m4!1e1!2s103437136001207715629!3m1!1e1!3m7!1s0x95273939ae3a09a3:0xe1ed6ba5242324a2!8m2!3d-27.5967026!4d-48.5535801!9m1!1b1!16s%2Fg%2F11smkb7v5y?entry=ttu"
            target="_blank"
          >
            <TestimonialSubTitle>
              <span>Avalie</span> você também!
            </TestimonialSubTitle>
            <img src={IconRating} alt="Avaliação" width={30} height={30} />
          </Anchor>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  margin: 220px 0 0;
  @media (max-width: 859px) {
    margin: 50px 0 0;
  }
`;
const LogoWrapper = styled.div`
  width: 90%;
  padding: 0 5%;
  cursor: pointer;
  :focus-visible {
    outline: none;
    border: 0px;
  }
`;
const TestimonialTitle = styled.h1`
  font-size: 2.1rem;
  text-align: center;
  margin-bottom: 30px;
  font-weight: 500;
  @media (max-width: 859px) {
    font-size: 1.575rem;
  }
`;
const Anchor = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 35px;
  gap: 10px;
  color: #000;
  :hover {
    color: unset;
  }
`;
const TestimonialSubTitle = styled.h2`
  font-size: 1.1rem;
  text-align: center;
  font-weight: 500;
  display: flex;
  > span {
    padding-right: 4px;
    text-decoration: underline;
  }
  @media (max-width: 859px) {
    font-size: 1rem;
  }
`;